import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, Subscription, debounceTime, takeUntil, timer } from 'rxjs';
import { CommonService } from '@tech-services/common.service';

@Component({
  selector: 'tech-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
})
export class LoadingScreenComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public textLoading: boolean = false;
  private unsubscribe$ = new Subject();
  private timeOut;

  constructor(
    private commonservice: CommonService,
    ) {
    this.textLoading = false;
  }

  ngOnInit() {
    this.textLoading = false;
    this.commonservice.loading$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((val) => {
      this.loading = val;
      this.textLoading = false;
    });
    this.commonservice.loading$
    .pipe(takeUntil(this.unsubscribe$),debounceTime(20000))
    .subscribe((val) => {
      if(val)   
          this.textLoading = true;
    });
  }

  ngOnDestroy(): void {
    this.textLoading = false;
    clearInterval(this.timeOut);
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
